// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"5c231da8","496":"8a560623"}[chunkId] + ".chunk.js";
};